import type { FullResultHistoryArg } from 'src/hooks/queries/dashboardFilterArgs';

import type { TableRecord } from '@/utils/table/types';

import type { WidgetDataSource } from '../../gigawidget/types';

/**
 * COI-838 — binds `fullResultHistory: true` onto a register data source, for the
 * two rating charts that plot the nested series rather than trending it.
 *
 * A descriptor transform rather than an option on `useGetWidgetData`: that hook's
 * seams exist to inject args DERIVED FROM DASHBOARD STATE at render time, whereas
 * this is a constant property of the widget. `useGetWidgetData` and
 * `WidgetDataSource` serve ~30 data sources and must not grow a member for two of
 * them.
 *
 * CALL IT AT MODULE SCOPE, not inside a component body — the wrapped
 * `useWidgetQuery` identity must be stable across renders.
 *
 * Deliberately NOT registered in the `dataSources` map: `Object.entries(dataSources)`
 * builds the user-facing source picker, so a registered variant would appear in the
 * widget settings UI.
 */
export const withFullResultHistory = <
  TItem extends TableRecord,
  TArgs extends FullResultHistoryArg,
  TData extends object,
>(
  source: WidgetDataSource<TItem, TArgs, TData>
): WidgetDataSource<TItem, TArgs, TData> => ({
  ...source,
  useWidgetQuery: (options) =>
    source.useWidgetQuery({
      ...options,
      queryArgs: { ...options.queryArgs, fullResultHistory: true },
    }),
});
